/**
 * @generated SignedSource<<5f44082df0cff8b280a9dd0e2b53ce6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCallDealerCta_user$data = {
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly " $fragmentType": "PdpSharedCallDealerCta_user";
};
export type PdpSharedCallDealerCta_user$key = {
  readonly " $data"?: PdpSharedCallDealerCta_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCallDealerCta_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCallDealerCta_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "86b13761a04eb4c8578a1d05709eb0e0";

export default node;
